import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)


// import HomeView from '../views/index.vue'
const HomeView = () => import('../views/index.vue')
// import Home from '../views/Home/home.vue'
const Home = () => import('../views/Home/home.vue')
// import Category from '../views/Category/categroy.vue'
const Category = () => import('../views/Category/categroy.vue')
// import About from '../views/Page/about.vue'
const About = () => import('../views/Page/about.vue')
// import Contact_us from '../views/Page/contact_us.vue'
const Contact_us = () => import('../views/Page/contact_us.vue')
// import Shopping_instructions from '../views/Page/shopping_instructions.vue'
const Shopping_instructions = () => import('../views/Page/shopping_instructions.vue')
// import Nav from '../views/Page/nav.vue'
const Nav = () => import('../views/Page/nav.vue')
// import myCart from '../views/Page/cart.vue'
const myCart = () => import('../views/Page/cart.vue')
// import Order from '../views/Page/order.vue'
const Order = () => import('../views/Page/order.vue')
// import Check_order from '../views/Page/check_order.vue'
const Check_order = () => import('../views/Page/check_order.vue')
// import Category_list from '../views/Category/category_list.vue'
const Category_list = () => import('../views/Category/category_list.vue')
// import All_category from '../views/Category/all_category.vue'
const All_category = () => import('../views/Category/all_category.vue')
// import Details from '../views/Category/details.vue'
const Details = () => import('../views/Category/details.vue')
// import Search from '../views/Category/search.vue'
const Search = () => import('../views/Category/search.vue')
// import Announcement from '../views/Page/announcement.vue'
const Announcement = () => import('../views/Page/announcement.vue')
// import Consumer_Rights from '../views/review/consumer_Rights.vue'
const Consumer_Rights = () => import('../views/review/consumer_Rights.vue')
// import Privacy_Policy from '../views/review/privacy_Policy.vue'
const Privacy_Policy = () => import('../views/review/privacy_Policy.vue')
// import Terms_Service from '../views/review/terms_Service.vue'
const Terms_Service = () => import('../views/review/terms_Service.vue')

const Article = () => import('../views/Article/index.vue')
const Article_id = () => import('../views/Article/page.vue')
const routes = [{
  path: '/',
  component: HomeView,
  children: [{
      path: '',
      name: 'home',
      component: Home,
    },
    {
      path: '/about',
      name: 'about',
      component: About,
    },
    {
      path: '/contact_us',
      name: 'contact_us',
      component: Contact_us,
    },
    {
      path: '/shopping_instructions',
      name: 'shopping_instructions',
      component: Shopping_instructions,
    },
    {
      path: '/announcement',
      name: 'announcement',
      component: Announcement,
    },
    {
      path: '/nav/:name',
      name: 'nav',
      component: Nav,
    },
    {
      path: '/cart',
      name: 'cart',
      component: myCart,
    },
    {
      path: '/order/:order_num',
      name: 'order',
      component: Order,
    },
    {
      path: '/check_order',
      name: 'check_order',
      component: Check_order,
    },
    {
      path: '/category',
      name: 'category',
      component: Category,
      children: [
        // {
        //   path: '/avtivity',
        //   name: 'avtivity',
        //   // component: () => import( /* webpackChunkName: "avtivity" */ '../views/Category/avtivity.vue'),
        //   component: Avtivity,
        // },
        {
          path: '/category_list/:id/:name',
          name: 'category_list',
          component: Category_list,
        },
        {
          path: '/all_category',
          name: 'all_category',
          component: All_category,
        },
        {
          path: '/details/:id',
          name: 'details',
          component: Details,
        },
        {
          path: '/search/:name',
          name: 'search',
          component: Search,
        }
      ]
    },
    {
      path: '/consumer_Rights',
      name: 'consumer_Rights',
      component: Consumer_Rights,
    },
    {
      path: '/privacy_Policy',
      name: 'privacy_Policy',
      component: Privacy_Policy,
    },
    {
      path: '/terms_Service',
      name: 'terms_Service',
      component: Terms_Service,
    },
    {
      path: '/article',
      name: 'article',
      component: Article,
    },
    {
      path: '/article/:id',
      name: 'article_id',
      component: Article_id,
    }
  ]
}, ]
// hash
// history
export default function createRouter() {
  const router = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
      // 始终滚动到顶部
      if (savedPosition) {
        return savedPosition
      } else {
        return {
          x: 0,
          y: 0
        }
      }
    },
  })
  return router
}